// extracted by mini-css-extract-plugin
module.exports = {"playlist-detail__more-dots-btn":"playlist-detail_playlist-detail__more-dots-btn__egDM9","playlist-detail__play-btn":"playlist-detail_playlist-detail__play-btn__Akym5"};